import axios from "axios";

const configuredBackendURL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = (() => {
  if (!configuredBackendURL) return "";
  try {
    const url = new URL(configuredBackendURL, window.location.origin);
    const loopbackHosts = new Set(["localhost", "127.0.0.1"]);
    if (
      loopbackHosts.has(url.hostname) &&
      loopbackHosts.has(window.location.hostname)
    ) {
      // Keep frontend and API on the same loopback hostname so local auth
      // cookies are sent consistently by the browser.
      url.hostname = window.location.hostname;
    }
    return url.toString().replace(/\/$/, "");
  } catch {
    return configuredBackendURL.replace(/\/$/, "");
  }
})();

export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export default api;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
